<template>
	<div class="container">
		<div class="text-center">
			<h1>Success!</h1>
			<p>Your email address has been verified!</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'VerificationSuccess'
	}
</script>

<style scoped>

</style>
